import { IconComponentsProps } from './types';

const EditIcon = ({ fill = 'currentColor', ...props }: IconComponentsProps) => (
  <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14 12V13H0V12H14ZM8.5 0.299805C8.9 -0.100098 9.50042 -0.100163 9.90039 0.299805L11.7002 2.09961C12.1002 2.49958 12.1001 3.1 11.7002 3.5L4.2002 11H1V7.7998L8.5 0.299805ZM2 8.2002V10H3.7998L8.7998 5L7 3.2002L2 8.2002ZM7.7002 2.5L9.5 4.2998L11 2.7998L9.2002 1L7.7002 2.5Z"
      fill={fill}
    />
  </svg>
);

export default EditIcon;
